import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../LanguageContext';
import { GlobeIcon } from 'lucide-react';
import { Logo } from './Logo';
export function LanguageModal() {
  const {
    setLanguage,
    hasSelectedLanguage
  } = useLanguage();
  if (hasSelectedLanguage) return null;
  return <AnimatePresence data-id="element-211">
      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-212">
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="absolute inset-0 bg-navy/80 backdrop-blur-sm" data-id="element-213" />

        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full overflow-hidden" data-id="element-214">
          {/* Decorative background */}
          <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-electric/10 rounded-full blur-3xl" data-id="element-215" />

          <div className="relative z-10 flex flex-col items-center text-center" data-id="element-216">
            <Logo className="h-10 mb-8" data-id="element-217" />

            <div className="w-16 h-16 bg-electric/10 rounded-full flex items-center justify-center mb-6 text-electric" data-id="element-218">
              <GlobeIcon className="w-8 h-8" data-id="element-219" />
            </div>

            <h2 className="text-2xl font-bold text-navy mb-2" data-id="element-220">
              Select your language
            </h2>
            <p className="text-slate-500 mb-8" data-id="element-221">
              Selecciona tu idioma preferido
            </p>

            <div className="grid grid-cols-1 gap-4 w-full" data-id="element-222">
              <button onClick={() => setLanguage('en')} className="flex items-center justify-between w-full p-4 rounded-xl border-2 border-slate-100 hover:border-electric hover:bg-slate-50 transition-all group" data-id="element-223">
                <div className="flex items-center gap-4" data-id="element-224">
                  <span className="text-2xl" data-id="element-225">🇺🇸</span>
                  <span className="font-semibold text-navy group-hover:text-electric transition-colors" data-id="element-226">
                    English
                  </span>
                </div>
              </button>

              <button onClick={() => setLanguage('es')} className="flex items-center justify-between w-full p-4 rounded-xl border-2 border-slate-100 hover:border-electric hover:bg-slate-50 transition-all group" data-id="element-227">
                <div className="flex items-center gap-4" data-id="element-228">
                  <span className="text-2xl" data-id="element-229">🇪🇸</span>
                  <span className="font-semibold text-navy group-hover:text-electric transition-colors" data-id="element-230">
                    Español
                  </span>
                </div>
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>;
}